import React from 'react'
import { Box } from '@mui/material'
import { UserMenu } from '@/components/layout'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const UserMenuSection = () => {
  const userWithPhoto = {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    avatar_url:
      'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=96&h=96&fit=crop&crop=faces',
  }

  const userWithoutPhoto = {
    id: 2,
    first_name: 'Jane',
    last_name: 'Smith',
  }

  return (
    <>
      <SubSection
        title='User Menu'
        description='Displays user avatar and name with a dropdown menu.'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='With photo'
            component={<UserMenu id='with-photo' donor={userWithPhoto} />}
          />
          <DemoComponent
            label='With Photo & Menu'
            component={
              <UserMenu id='no-photo' donor={userWithPhoto} showMenu />
            }
          />
          <DemoComponent
            label='Without photo'
            component={<UserMenu id='with-photo' donor={userWithoutPhoto} />}
          />
          <DemoComponent
            label='Without photo & menu'
            component={
              <UserMenu id='with-photo' donor={userWithoutPhoto} showMenu />
            }
          />
        </StyledDemoGrid>
        <Box sx={{ mt: 2 }} />
      </SubSection>
    </>
  )
}
